import { Button } from '@progress/kendo-react-buttons';
import { GridToolbar } from '@progress/kendo-react-grid';
import { RadioGroup } from '@progress/kendo-react-inputs';
import PropTypes from 'prop-types';
import React from 'react';

export default function Toolbar(props) {
  const data = [
    { label: "Tous", value: "tous" },
    { label: "Actifs", value: "actifs" },
    { label: "Inactifs", value: "inactifs" },
  ];

  return (
    <GridToolbar>
      {props.showCheckbtn && (
        <Button
          onClick={props.onCheckBoxClick}
          className={props.txtCheckBox === "Tous affichés" ? "blueButton" : "redButton"}>
          {props.txtCheckBox}
        </Button>
      )}
      <div className="me-auto"></div>
      {props.diffuseur && <RadioGroup data={data} layout='horizontal' style={{ marginRight: '20px' }} defaultValue={data[0].value} onChange={(event) => props.setStatuts(event.value === 'tous' ? null : event.value === 'actifs' ? true : false)} />}
      {props.onSearchChange !== undefined ? (
        <span className="k-textbox k-grid-search k-display-flex"
          style={{
            width: '250px',
            backgroundColor: props.gantt ? "#f3f5f5" : "", borderRadius: props.gantt ? "25px" : ""
          }}>
          <input
            autoComplete="off"
            placeholder="Rechercher"
            title="Rechercher"
            className="k-input"
            onChange={props.onSearchChange}
            style={{ backgroundColor: props.gantt ? "inherit" : "" }} />
        </span>
      ) : null}
      {props.showCreateBtn && (
        <Button
          onClick={props.onCreateClick}
          className="blueButton">
          {props.txtBtn}
        </Button>
      )}
      {props.showCreateBtn2 && (
        <Button
          onClick={props.onCreateClick2}
          className="blueButton">
          {props.txtBtn2}
        </Button>
      )}
      {props.canExport && (
        <button
          title="Export PDF"
          className="k-button k-primary blueButton"
          onClick={props.exportPDF}>
          Exporter en PDF
        </button>
      )}
    </GridToolbar>
  );
}

Toolbar.propTypes = {
  onCreateClick: PropTypes.func,
  onCreateClick2: PropTypes.func,
  onCheckBoxClick: PropTypes.func,
  onSearchChange: PropTypes.func,
  showCreateBtn: PropTypes.bool,
  showCreateBtn2: PropTypes.bool, showCheckbtn: PropTypes.bool,
  txtBtn: PropTypes.string,
  txtBtn2: PropTypes.string,
  txtCheckBox: PropTypes.string,
  onNavigate: PropTypes.func,
  exportPDF: PropTypes.func,
  canExport: PropTypes.bool,
  gantt: PropTypes.bool,
  diffuseur: PropTypes.bool,
  setStatuts: PropTypes.any
};
